import { render, staticRenderFns } from "./ModalSelectSerial.vue?vue&type=template&id=2dd275b5&scoped=true"
import script from "./ModalSelectSerial.vue?vue&type=script&lang=js"
export * from "./ModalSelectSerial.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectSerial.vue?vue&type=style&index=0&id=2dd275b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd275b5",
  null
  
)

export default component.exports